export const ARRAY_LANDING_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=MSJMKPFJKF&ek=hEBnLtkp&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
export const CHECKLIST_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=QKPLKSDEHK&ek=B7KLm3PP&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
export const UNBOX_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=OLJPJMGLGE&ek=wtdDbl7V&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
// RAIKIT
export const RACK_STEP1_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=RONRQQJLEL&ek=FmOuljDo&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
// STEP2
export const RACK_STEP2_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=QKPLKSDEHK&ek=QGmA4bQA&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
// BEZEL
export const RACK_STEP3_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=OOSLQRHKIG&ek=gCk7McqR&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
export const CABLES_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=QQOSNQJFJI&ek=bQvc4UTQ&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
export const POWER_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=QONSRPEMKG&ek=2LyYjyii&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';

export const DHCI_RACK_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=NSMNROGEDE&ek=St5oC5ZQ&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
export const DHCI_CABLE_STEP1_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=OSNJNQIHJE&ek=rmwo4Wef&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
export const DHCI_CABLE_STEP1_BROWN_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=OKKSQLJHHK&ek=rmwo4Wef&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
export const DHCI_CABLE_STEP2_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=KOJSNKFIID&ek=tdKZvnGw&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
export const DHCI_CABLE_STEP2_BROWN_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=MLRNRNFJKJ&ek=tdKZvnGw&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
export const DHCI_CABLE_STEP3_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=NMOOMJGFMM&ek=8XgTdllj&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
export const DHCI_CABLE_STEP3_BROWN_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=NJNJRSJLHG&ek=8XgTdllj&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';

export const DHCI_MANAGEMENT_SUBNET_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=KOJSNKFIID&ek=tdKZvnGw&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
export const DHCI_DATA_SUBNET_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=NMOOMJGFMM&ek=8XgTdllj&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
export const DHCI_SWITCH_CONFIGURE_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=KSQKKOHIEL&ek=KFZnRVny&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
export const DHCI_SWITCH_CONFIGURE_BROWN_VIDEO =
  '//media.now.hpe.com/EmbeddedPlayer.ashx?key=NQLKMNILIE&ek=KFZnRVny&pb=0&play=0&width=100%&height=100%&xdomain=1&targetdivid=playerDiv';
